import { ActionTypes } from 'src/types/types';

export const FEATURE_NAME = 'eventsFilters';
export const actionTypes = {
  FETCH_FILTERS_VALUES: `${FEATURE_NAME}/FETCH_FILTERS_VALUES`,
  LOAD_MORE_OCCURRENCES: `${FEATURE_NAME}/LOAD_MORE_OCCURRENCES`,
} satisfies ActionTypes<typeof FEATURE_NAME>;
